import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';


//pictures for gallery

import gp1 from '../../assets/Pretty_Lashed/gp/lashpic1.png';
import gp2 from '../../assets/Pretty_Lashed/gp/lashpic2.JPG';
import gp3 from '../../assets/Pretty_Lashed/gp/lashpic3.PNG';
import gp4 from '../../assets/Pretty_Lashed/gp/lashpic4.PNG';
import gp5 from '../../assets/Pretty_Lashed/gp/lashpic5.JPG';
import gp6 from '../../assets/Pretty_Lashed/gp/lashpic6.JPG';
import gp7 from '../../assets/Pretty_Lashed/gp/lashpic7.JPG';
import gp8 from '../../assets/Pretty_Lashed/gp/lashpic8.JPG';
import gp9 from '../../assets/Pretty_Lashed/gp/lashpicblondie.png';
import gp10 from '../../assets/Pretty_Lashed/gp/roundbox1.JPG';
import gp11 from '../../assets/Pretty_Lashed/gp/shanise_smile_pic.JPG';
import gp12 from '../../assets/Pretty_Lashed/gp/sigbox.JPG';


const Row = styled.div`
 {
    display: flex;
    flex-wrap: wrap;
    padding: 0 4px;
  };


` 
  
  /* Create two equal columns that sits next to each other */
const Column = styled.div `
{
    flex: 25%;
    padding: 0 10px;
  }
` 
  
 const Galpic = styled.img`
   {
    margin-top: 8px;
    vertical-align: middle;
   }
 
 ` 




class GalleryVideos extends Component{
    render(){
      return(
          <div>
            <section className="primary-nav light center btn">
              <Link to="/products"><strong>Products</strong></Link>
              <Link to="/styles"><strong>Styles</strong></Link>
              <Link to="/"><strong>Home</strong></Link>
              <Link to="/about"><strong>About</strong></Link>
           </section>
            <div className="large-header content primary-nav center btn" style={{color: "white"}}>
              <Link to="/cart"><strong>View Cart</strong></Link>
            </div>
           <div>
           <h2 style={{textAlign : "center"}}>Want to be featured in our gallery?</h2>
           <h5 style={{textAlign : "center"}}>Log on to your favorite social media platform and hashtag us in your best <strong>#Pretty&Lashed</strong> selfie !  </h5>
           </div>
               <section >
                 <Row className="row">
                   <Column className="column">
                     <Galpic src={gp1}/>
                     <Galpic src={gp2}/>
                     <video width="540" height="540" controls class="video-container video-container-overlay"  muted="" data-reactid=".0.1.0.0"><source type="video/mp4" data-reactid=".0.1.0.0.0" src="https://firebasestorage.googleapis.com/v0/b/prettylashed-c38d7.appspot.com/o/videos%2FIMG_6271.mp4?alt=media&token=66dd2e7f-d476-43ea-867c-849cb619d08e"/> </video>
                     <Galpic src={gp3}/>
                     <Galpic src={gp7}/>
                   </Column>
                   <Column className="column">
                     <Galpic src={gp10}/>
                     <Galpic src={gp11}/>
                     <Galpic src={gp12}/>
                     <video width="540" height="540" controls class="video-container video-container-overlay"  data-reactid=".0.1.0.0"><source type="video/mp4" data-reactid=".0.1.0.0.0" src="https://firebasestorage.googleapis.com/v0/b/prettylashed-c38d7.appspot.com/o/videos%2FIMG_5865.mp4?alt=media&token=e6d7e5e1-9190-4557-8356-f888b6571723"/> </video>
                     <Galpic src={gp6}/>
                     <video width="540" height="540" controls class="video-container video-container-overlay"   data-reactid=".0.1.0.0"><source type="video/mp4" data-reactid=".0.1.0.0.0" src="https://firebasestorage.googleapis.com/v0/b/prettylashed-c38d7.appspot.com/o/videos%2FIMG_5956.mp4?alt=media&token=15ee17ab-d304-4054-b934-7c80d14e9627"/> </video>
                   </Column>
                   <Column className="column">
                     <Galpic src={gp5}/>
                     <Galpic src={gp9}/>
                     <Galpic src={gp4}/>
                     <video width="540" height="540" controls class="video-container video-container-overlay"   data-reactid=".0.1.0.0"><source type="video/mp4" data-reactid=".0.1.0.0.0" src="https://firebasestorage.googleapis.com/v0/b/prettylashed-c38d7.appspot.com/o/videos%2FIMG_6008.mp4?alt=media&token=5d3da51d-d95b-4302-9ccb-ed0fb08af2ff"/> </video>
                     <Galpic src={gp8}/>
                   </Column>
                 </Row>
               </section>
          </div>
      )
 }
};

export default GalleryVideos;


// WEBPACK FOOTER //
// ./src/components/Gallery/GalleryVideos.js